module.exports = __webpack_public_path__ + "media/components/assets/icons/deposit_without_bank-1eb923862e774b6185002c154441114c.svg";